{
  "INTEGRATION_APPS": {
    "FETCHING": "Obteniendo integraciones",
    "NO_HOOK_CONFIGURED": "No hay integraciones de {integrationId} configuradas en ésta cuenta.",
    "HEADER": "Aplicaciones",
    "STATUS": {
      "ENABLED": "Activado",
      "DISABLED": "Deshabilitado"
    },
    "CONFIGURE": "Configurar",
    "ADD_BUTTON": "Añadir un nuevo hook",
    "DELETE": {
      "TITLE": {
        "INBOX": "Confirme eliminación",
        "ACCOUNT": "Desconectar"
      },
      "MESSAGE": {
        "INBOX": "¿Está seguro de eliminar?",
        "ACCOUNT": "¿Está seguro en desconectar?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Sí, eliminar",
        "ACCOUNT": "Si, desconectar"
      },
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "API": {
        "SUCCESS_MESSAGE": "Hook borrado correctamente",
        "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
      }
    },
    "LIST": {
      "FETCHING": "Obteniendo hooks de integración",
      "INBOX": "Bandeja de entrada",
      "DELETE": {
        "BUTTON_TEXT": "Eliminar"
      },
      "EDIT": {
        "BUTTON_TEXT": "Editar"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Seleccione una bandeja de entrada",
          "PLACEHOLDER": "Seleccione una bandeja de entrada"
        },
        "SUBMIT": "Crear",
        "CANCEL": "Cancelar"
      },
      "API": {
        "SUCCESS_MESSAGE": "Hook de integración añadida correctamente",
        "ERROR_MESSAGE": "No se pudo conectar al servidor Woot, por favor inténtalo de nuevo más tarde"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Conectar"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Desconectar"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Obtén datos de tu propio servidor y muéstralos en la barra lateral de la conversación. Devuelve HTML (mostrado en un iframe) o JSON (mostrado como una lista de clave/valor).",
      "DIALOGFLOW": "Dialogflow es una plataforma de procesamiento del lenguaje natural para construir interfaces de conversación. Integrándolo con {installationName} permite a los bots gestionar consultas primero y transferirlas a los agentes cuando sea necesario. Ayuda a calificar a los clientes potenciales y a reducir la carga de trabajo de los agentes respondiendo a las preguntas frecuentes. Para añadir Dialogflow, cree una cuenta de servicio en la consola de Google y comparta las credenciales. Consulte la documentación para obtener más detalles",
      "DAKTELA": "Sincroniza correos electrónicos y chats web con tu cuenta de daktela.",
      "RETINO": "Retino pone orden en la gestión de devoluciones y reclamaciones.",
      "MAILSHIP": "Mailship es un sistema de gestión de almacén y cumplimiento de pedidos. Consulta el estado del pedido, seguimiento y detalles de envío.",
      "RAYNET": "Conecta tu cuenta de Raynet CRM para acceder a los datos de tus clientes. Añade una conexión con tu nombre de usuario y token de API de Raynet."
    },
    "EDIT": {
      "TITLE": "Editar {name}",
      "FORM": {
        "INBOX": {
          "LABEL": "Seleccionar bandeja de entrada",
          "PLACEHOLDER": "Seleccionar bandeja de entrada"
        },
        "SUBMIT": "Actualizar",
        "CANCEL": "Cancelar"
      },
      "API": {
        "SUCCESS_MESSAGE": "Hook de integración actualizado correctamente",
        "ERROR_MESSAGE": "No se pudo conectar al servidor de chat, por favor inténtalo más tarde"
      }
    },
    "TEST_CONNECTION": {
      "BUTTON": "Probar conexión",
      "SUCCESS": "Conexión exitosa",
      "ERROR": "La conexión falló. Por favor, verifica tus credenciales."
    }
  }
}
